class func {
    handleSet(origin,data){
        Object.keys(data).forEach((key)=>{
            if (origin[key]){
                if (typeof(origin[key])==='object'){
                    this.handleSet(origin[key],data[key]);
                } else{
                    origin[key]=data[key]
                }
            }
        });
    }

    connectData(data,parent){
        Object.keys(data).forEach((key)=>{
            parent[key]=data[key]
        });
    }
}

export default  new func()


